"use strict";
exports.__esModule = true;
exports.parsePrice = void 0;
var formatter = new Intl.NumberFormat('fa-IR');
var parsePrice = function (value) {
    if (value) {
        return formatter.format(parseInt(value.toString()));
    }
    return 0;
};
exports.parsePrice = parsePrice;
//# sourceMappingURL=parse-price.js.map